import { all } from 'redux-saga/effects'

import { gapRiskRootSaga } from '../state/gap-risk-slice'

export function* rootSaga() {
  yield all([gapRiskRootSaga()])
}
